import React, { useState, useEffect } from 'react';
import HeaderContainer from './HeaderContainer';

const Header = (props) => {
	
	const [navbar, setNavbar] = useState(false);
	const [bgColor, setBgColor] = useState('transparent');
	
 	useEffect(() => (
		window.addEventListener("scroll", changeBackground)
 	), []);

 	useEffect(() => {
		if(props.bg) {
 			setBgColor(props.bg)			
		}
 	},[props.bg]);

	const changeBackground = () => {
	 	if (window.scrollY >= 100) {
	 	    setNavbar(true)   
	 	} else {    
	 	    setNavbar(false)   
	 	}
	}

	return (
		<div className={navbar ? "main-header active vis-searchdec" : "main-header vis-searchdec"} style={{ backgroundColor: bgColor === "color" ? "#f5f5f5" : ''}}>	        	
			<HeaderContainer
				bgColor={bgColor}
				navbar={navbar}
			/>
		</div>
	)
}

export default Header;